export default "__VITE_ASSET__D6QQwyW1__"